import React from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { Mail, MessageCircle, Clock, MapPin, Headphones } from 'lucide-react';
import ContactForm from '../Components/ContactForm'; // ✅ import

const WHATSAPP_NUMBER = '918178909878';
const DISPLAY_WHATSAPP = '+91 8178909878';
const EMAIL = 'wicunatech@gmail.com';

const Contact = () => {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}`;

  return (
    <>
      <Navbar />

      {/* ── Hero ── */}
      <section className="bg-gray-900 py-14 px-4 text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-3">
          Contact <span className="text-blue-400">Us</span>
        </h1>
        {/* <p className="text-blue-100 text-lg">Get in touch — we're here to help.</p> */}
      </section>

      {/* ── Main Section ── */}
      <section className="py-14 px-4 bg-gray-50">
        <div className="max-w-5xl mx-auto grid lg:grid-cols-[1fr_1.4fr] gap-10 items-start">

          {/* ── Left: Contact Info ── */}
          {/* ── Left: Contact Info ── */}
<div>
  <h2 className="text-xl font-bold text-gray-900 mb-4">Contact Information</h2>

  {/* shared card classes */}
  {/* clickable: "... group hover:border-X hover:shadow-sm" */}
  {/* static:    "... cursor-default"                       */}

  {/* WhatsApp */}
  
   <a href={whatsappUrl}
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100 hover:border-gray-200 hover:shadow-sm transition-all group mb-3"
  >
    <div className="w-11 h-11 rounded-xl bg-green-50 text-green-600 flex items-center justify-center flex-shrink-0 group-hover:bg-green-500 group-hover:text-white transition-colors">
      <MessageCircle className="w-5 h-5" />
    </div>
    <div>
      <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-0.5">WhatsApp</p>
      <p className="text-sm font-semibold text-gray-900">{DISPLAY_WHATSAPP}</p>
      <p className="text-xs text-green-600 mt-0.5">Chat with us →</p>
    </div>
  </a>

  {/* Email */}
  
   <a href={`mailto:${EMAIL}`}
    className="flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100 hover:border-gray-200 hover:shadow-sm transition-all group mb-3"
  >
    <div className="w-11 h-11 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center flex-shrink-0 group-hover:bg-blue-500 group-hover:text-white transition-colors">
      <Mail className="w-5 h-5" />
    </div>
    <div>
      <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-0.5">Email</p>
      <p className="text-sm font-semibold text-gray-900 break-all">{EMAIL}</p>
      <p className="text-xs text-blue-600 mt-0.5">Send an email →</p>
    </div>
  </a>

  {/* Working Hours */}
  <div className="flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100 mb-3 cursor-default">
    <div className="w-11 h-11 rounded-xl bg-indigo-50 text-indigo-500 flex items-center justify-center flex-shrink-0">
      <Clock className="w-5 h-5" />
    </div>
    <div>
      <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-0.5">Working hours</p>
      <p className="text-sm font-semibold text-gray-900">Mon – Fri, 9am – 6pm IST</p>
    </div>
  </div>

  {/* Location */}
  <div className="flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100 mb-3 cursor-default">
    <div className="w-11 h-11 rounded-xl bg-amber-50 text-amber-500 flex items-center justify-center flex-shrink-0">
      <MapPin className="w-5 h-5" />
    </div>
    <div>
      <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-0.5">Location</p>
      <p className="text-sm font-semibold text-gray-900">India</p>
    </div>
  </div>

  {/* Response Time */}
  <div className="flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100 cursor-default">
    <div className="w-11 h-11 rounded-xl bg-teal-50 text-teal-500 flex items-center justify-center flex-shrink-0">
      <Headphones className="w-5 h-5" />
    </div>
    <div>
      <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-0.5">Response time</p>
      <p className="text-sm font-semibold text-gray-900">Within 24 hours</p>
    </div>
  </div>

</div>


          {/* ── Right: ContactForm Component ── */}
          <div className="bg-white rounded-2xl p-8 border border-gray-100">
            <ContactForm /> {/* ✅ replaced the inline form with component */}
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
};

export default Contact;